<template>
  <div class="hello" v-if="schema">
    <h1>Data Editor: {{schema.title}}</h1>
    <router-link to="/" >Back to Dashboard</router-link>
    <div>
        <b-tabs>
          <b-tab title="Entries" active>
           <EntriesTable  :schema="schema" />
          </b-tab>
          <b-tab v-for="refProp in schema.refProperties" v-bind:key="refProp.name" :title="refProp.title" @click="reloadFromServer">
           <RefTable :schema="schema" :refDef="refProp" />
          </b-tab>
        </b-tabs>
    </div>
  </div>
</template>

<script>

import {BackendApiService} from '../../services/BackendApiService'
import EntriesTable from './EntriesTable'
import RefTable from './RefTable'

export default {

  name: 'DataEditor',
  components: {EntriesTable, RefTable},
  mounted () {
    BackendApiService.getSchema(this.$route.params.schemaId).then(response => {
      this.schema = response.data
    })
  },
  data () {
    return {
      schema: null
    }
  },
  computed: {
    tabs () {
      return [{label: 'entries', content: EntriesTable}]
    },
    isAdmin () {
      return this.$store.getters.isAdmin
    }
  },
  methods: {
    reloadFromServer () {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/editor/DataEditor.vue